var RoutesMixin = {
  methods: {
    goToRoot() {
      this.to({ name: 'root' });
    },
    goToDashboardtView(tabName, subTabName) {
      this.to({
        name: 'dashboard',
        params: {
          tab: tabName,
          subTab: subTabName
        }
      })
    },
    goToNewDraftView(claimType, step) {
      this.to({
        name: 'draft',
        params: {
          claimType: claimType,
          step: step
        }
      })
    },
    goToEditDraftView(claimType, step, draftId) {
      this.to({
        name: 'draft',
        params: {
          claimType: claimType,
          step: step,
          draftId: draftId
        }
      })
    },
    goToDebtView(claimType, draftId) {
      this.to({
        name: 'debt',
        params: {
          claimType: claimType,
          step: "debt",
          draftId: draftId,
          bonoUsado: true
        }
      })
    },
    goToClaimView(claimToken) {
      this.to({
        name: 'claim',
        params: {
          token: claimToken
        }
      })
    },
    goToExpedientView(expedientUuid) {
      this.to({
        name: 'expedient',
        params: {
          uuid: expedientUuid
        }
      })
    },
    goToConsultaRealizada(tokenSolicitud) {
      this.to({
        name: 'consultaRealizada',
        params: {
          tokenSolicitud: tokenSolicitud
        }
      })
    },
    goToConsultaTerceros() {
      this.to({ name: 'consultaFichero' })
    },
    goToNewConsultaTercerosParam(codType) {
      this.to({
        name: 'consultaFichero',
        params: {
          codType: codType
        }
      })
    },
    goToConsultaTercerosParam(codType, draftId) {
      this.to({
        name: 'consultaFichero',
        params: {
          codType: codType,
          draftId: draftId
        }
      })
    },
    goToFichaConsulta(token, deudas) {
      this.to({
        name: 'grandes-cuentas_consultas-detalle',
        params: {
          token: token,
          deudas: deudas
        }
      })
    },
    goToListaConsultas() {
      this.to({
        name: 'grandes-cuentas_consultas'
      })
    },
    goToListaExpedientesGrandesCuentas(referenciaCliente) {
      this.to({
        name: 'portal-expedientes',
        params: {
          refCli: referenciaCliente
        }
      })
    },
    goToNuevaOperacion() {
      this.to({
        name: 'nuevoExpediente'
      })
    },
    goToClaimViewFromAltaReclamacion(claimToken) {
      this.to({
        name: 'claimFromAlta',
        params: {
          token: claimToken,
          altaOK: true
        }
      })
    },
    goTo403View() {
      this.to({
        name: 'http403'
      })
    },
    goTo404View() {
      this.to({
        name: 'http404'
      })
    },
    goToProfile() {
      this.to({
        name: 'profile'
      })
    },
    to(route) {
      this.$router.push(route)
        .catch(() => window.scrollTo(0, 0))
    }
  }
};

export default RoutesMixin